function copyToClipboard(text, el) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    let successful = false;
    try {
        successful = document.execCommand('copy');
    } catch (err) {
        successful = false;
    }
    document.body.removeChild(textarea);

    // ✅ Mostrar tick si se copió bien
    if (successful && el) {
        const original = el.innerHTML;
        el.innerHTML = "✅";
        setTimeout(() => {
            el.innerHTML = original;
        }, 1000);
    }
}


function hotspot(coordsArray, visibleArray) {
    const hotspots = coordsArray.map(c => {
        let [x, y] = (c || "50,50").split(",").map(n => parseFloat(n.trim()) || 50);
        return { x, y, dragging: false };
    });

    return {
        hotspots,
        visible: visibleArray,

        startDrag(index, e) {
            if (!Shopify.designMode) return;
            if (e.target.tagName.toLowerCase() === 'button') return;

            e.stopPropagation();
            e.preventDefault();
            this.hotspots[index].dragging = true;

            const card = e.currentTarget.closest('.relative.overflow-visible');
            if (!card) return;
            const rect = card.getBoundingClientRect();

            const move = (ev) => {
                const newX = ((ev.clientX - rect.left) / rect.width) * 100;
                const newY = ((ev.clientY - rect.top) / rect.height) * 100;
                this.hotspots[index].x = Math.min(100, Math.max(0, +newX.toFixed(1)));
                this.hotspots[index].y = Math.min(100, Math.max(0, +newY.toFixed(1)));
            };

            const up = () => {
                this.hotspots[index].dragging = false;
                window.removeEventListener('mousemove', move);
                window.removeEventListener('mouseup', up);
            };

            window.addEventListener('mousemove', move);
            window.addEventListener('mouseup', up);
        },

        showCoords(index) {
            return `${this.hotspots[index].x},${this.hotspots[index].y}`;
        },

        openPopup(index) {
            if (Shopify.designMode) return;

            const card = event.currentTarget.closest('[data-pswp]');
            const pswpPath = card?.dataset.pswp;
            if (!pswpPath) return;

            const allSnippets = Array.from(card.querySelectorAll('.hotspot-snippets > *'))
                .filter((_, i) => this.visible[i]);
            if (!allSnippets.length) return;

            // Creamos la instancia
            const lightbox = new PhotoSwipeLightbox({
                dataSource: allSnippets.map(snippet => ({ html: snippet.outerHTML })),
                pswpModule: () => import(pswpPath)
            });

            lightbox.on('contentAppend', (e) => {
                if (window.Alpine) Alpine.initTree(e.content.element);
            });

            // Guardamos la instancia global **antes de abrir**
            window.currentLightbox = lightbox;

            lightbox.init();
            lightbox.loadAndOpen(index >= 0 ? index : 0);
        },

    }
}
